export default {
	student: "student",
	guest: "guest",
	defender: "defender",
	director: "director",
	coordinator: "coordinator",
	exhibitor: "exhibitor",
	professional: "professional",
	family: "family",
	speaker: "speaker"
};
